import React from "react";
import { Link } from "react-router-dom";

export default function SingleHotelRoomCard(props) {
  return (
    <>
      <Link to={`/hotel/${props.id}`}
        className={`col-lg-4 col-sm-6 col-12 mb-lg-${props.mb} mb-sm-4 mb-5 px-2 text-decoration-none single-hotel-room-card`}
      >
        <div className="card-content-cover">
          <div
            className="image-side mb-3"
            style={{ background: `url(${props.img})` }}
          ></div>
          <div className="details-side">
            <h5 className="hotel-name text-capitalize">{props.title}</h5>
            <div className="hotel-details d-flex gap-3 justify-content-start align-items-center mb-1">
              <p className="m-0 hotel-ratings text-capitalize">
                {props.rating} - {props.ratingReview}
              </p>
              <p className="m-0 hotel-location d-flex align-items-center gap-1 text-capitalize">
                <i className="fa-solid fa-location-dot"></i>
                {props.cityAsLocation}
              </p>
            </div>
            <p className="mb-2 hotel-night-price">
              Per day starts at ${props.perDayPrice}
            </p>
          </div>
        </div>
      </Link>
    </>
  );
}
